// extracted by mini-css-extract-plugin
export default {"misc-page":"Misc_misc-page__+5sEd"};